(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-template"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var topicEl = document.getElementById('contactTopic');
    var orderGroup = document.getElementById('orderNumberGroup');
    var orderInput = document.getElementById('contactOrderNumber');
    var form = document.getElementById('enhanced-contact-form')?.closest('form');
    var emailEl = document.getElementById('contactFormEmail');
    var nameEl = document.getElementById('contactFormName');
    var messageEl = document.getElementById('contactFormMessage');
    var consentEl = document.getElementById('contactConsent');
    var photosEl = document.getElementById('contactPhotos');
    var subjectEl = document.getElementById('contactFormSubject');

    function setError(id, msg) {
      var el = document.getElementById(id);
      if (!el) return;
      el.textContent = msg || '';
      el.classList.toggle('d-none', !msg);
    }

    function showOrderIfNeeded() {
      var v = topicEl ? topicEl.value : '';
      var needsOrder = v === 'order' || v === 'returns' || v === 'damaged';
      if (orderGroup) {
        orderGroup.classList.toggle('d-none', !needsOrder);
      }
      if (!needsOrder && orderInput) {
        orderInput.value = '';
        setError('error-order');
      }
    }

    function updateSubject() {
      if (!subjectEl || !topicEl) return;
      var map = {
        order: 'Order status / delivery',
        returns: 'Returns & refunds',
        care: 'Product / plant care question',
        damaged: 'Damaged or missing items',
        partnerships: 'Partnerships / press',
        other: 'Other',
      };
      var label = map[topicEl.value] || 'Contact form submission';
      subjectEl.value = label + ' — ' + (nameEl?.value || '');
    }

    function validateEmail(value) {
      // Simple email pattern
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function validateFiles() {
      if (!photosEl || !photosEl.files) return true;
      var maxSize = 5 * 1024 * 1024; // 5MB
      for (var i = 0; i < photosEl.files.length; i++) {
        var f = photosEl.files[i];
        var typeOk = ['image/jpeg', 'image/png'].indexOf(f.type) !== -1;
        if (!typeOk) {
          setError('error-photos', 'Only JPG and PNG files are accepted.');
          return false;
        }
        if (f.size > maxSize) {
          setError('error-photos', 'Each file must be 5MB or smaller.');
          return false;
        }
      }
      setError('error-photos');
      return true;
    }

    if (topicEl) {
      topicEl.addEventListener('change', function () {
        showOrderIfNeeded();
        setError('error-topic');
        updateSubject();
      });
    }
    if (nameEl) {
      nameEl.addEventListener('input', function () {
        setError('error-name');
        updateSubject();
      });
    }
    if (emailEl) {
      emailEl.addEventListener('input', function () {
        setError('error-email');
      });
    }
    if (messageEl) {
      messageEl.addEventListener('input', function () {
        setError('error-message');
      });
    }
    if (photosEl) {
      photosEl.addEventListener('change', validateFiles);
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        var hasError = false;
        // Name
        if (!nameEl || !nameEl.value.trim()) {
          setError('error-name', 'Please enter your full name.');
          hasError = true;
        }
        // Email
        if (!emailEl || !validateEmail(emailEl.value)) {
          setError('error-email', 'Please enter a valid email address.');
          hasError = true;
        }
        // Topic
        if (!topicEl || !topicEl.value) {
          setError('error-topic', 'Please choose a topic.');
          hasError = true;
        }
        // Order number if required
        var v = topicEl ? topicEl.value : '';
        if ((v === 'order' || v === 'returns' || v === 'damaged') && orderInput && !orderInput.value.trim()) {
          setError('error-order', 'Please enter your order number.');
          hasError = true;
        }
        // Message
        if (!messageEl || !messageEl.value.trim()) {
          setError('error-message', 'Please enter a message.');
          hasError = true;
        }
        // Consent
        if (!consentEl || !consentEl.checked) {
          setError('error-consent', 'You must agree to the Privacy Policy.');
          hasError = true;
        }
        // Files
        if (!validateFiles()) {
          hasError = true;
        }
        updateSubject();
        if (hasError) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    // Initialize
    showOrderIfNeeded();
    updateSubject();
  });

  } catch(e) { console.error(e); }
})();
})();
